var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeToJoinOrgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 214,
    viewBox: "0 0 429 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 128.721C399.885 129.783 397.836 130.633 395.716 131.128C390.134 132.403 384.552 131.341 380.1 128.438C375.719 125.677 372.398 121.216 371.126 115.764C368.582 104.719 375.436 93.6739 386.46 91.125C397.483 88.5761 408.506 95.4439 411.05 106.489C413.099 115.339 409.071 124.261 401.652 128.721Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M397.34 108.826C397.27 112.296 394.443 115.057 391.051 114.986C387.589 114.915 384.833 112.083 384.904 108.685C384.974 105.215 387.801 102.454 391.193 102.525C394.655 102.525 397.411 105.357 397.34 108.826Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M401.652 126.102V128.651C399.885 129.713 397.836 130.563 395.716 131.058C390.134 132.333 384.551 131.271 380.1 128.368V125.819C380.17 119.871 385.046 115.057 390.982 115.128C396.988 115.269 401.722 120.155 401.652 126.102Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3987 70.7328C22.1974 71.4408 20.9255 72.0072 19.5123 72.2904C15.8379 73.1401 12.2341 72.432 9.26628 70.5204C6.4398 68.6795 4.24928 65.7766 3.40133 62.2365C1.70544 55.0146 6.22781 47.7927 13.4353 46.0934C20.6429 44.3942 27.8504 48.9256 29.5463 56.1474C30.8889 61.9533 28.2744 67.7591 23.3987 70.7328Z",
    fill: "url(#paint0_linear_13096:34708)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 57.7062C20.5714 59.9719 18.6636 61.7419 16.473 61.7419C14.2119 61.7419 12.4453 59.8302 12.4453 57.6354C12.4453 55.3697 14.3532 53.5996 16.5437 53.5996C18.8049 53.5996 20.5714 55.4405 20.5714 57.7062Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.398 69.0344V70.7336C22.1968 71.4417 20.9249 72.0081 19.5116 72.2913C15.8372 73.1409 12.2334 72.4329 9.26562 70.5212V68.822C9.33629 64.9278 12.5161 61.8125 16.4025 61.8125C20.3596 61.8833 23.4687 65.1402 23.398 69.0344Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5967 100.397L0.96875 106.768L4.99735 136.371L51.6253 130.001L47.5967 100.397Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6382 100.398C46.013 102.452 44.3171 104.434 42.6919 106.487C40.996 108.47 39.3001 110.452 37.6749 112.435C35.9083 114.488 34.1418 116.541 32.3752 118.595C32.3045 118.666 32.3045 118.736 32.2339 118.807C30.6793 120.577 29.0541 122.418 27.4995 124.188L27.2875 124.471L27.0049 124.259C25.0263 122.914 22.9771 121.639 20.9986 120.294C20.9279 120.223 20.8573 120.223 20.7866 120.152C18.5254 118.666 16.2643 117.179 14.0031 115.621C11.8832 114.205 9.69269 112.718 7.57282 111.231C5.45296 109.744 3.26244 108.258 1.14258 106.7C3.3331 107.974 5.52363 109.32 7.71415 110.665C9.90467 112.01 12.0952 113.355 14.2857 114.701C16.6882 116.187 19.1614 117.745 21.5639 119.303C23.4011 120.436 25.2383 121.639 27.0049 122.772C28.4181 121.144 29.902 119.515 31.3153 117.957C33.2231 115.833 35.2017 113.639 37.1096 111.514C38.8761 109.603 40.572 107.691 42.3386 105.85C44.1051 104.08 45.801 102.169 47.6382 100.398Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6349 120.012C21.6349 120.083 21.6349 120.083 21.6349 120.012C21.3522 120.295 21.1402 120.578 20.9283 120.791C19.8683 121.923 18.8084 123.056 17.7485 124.118C16.4059 125.464 15.0633 126.738 13.6501 128.012C12.2368 129.287 10.8942 130.561 9.41034 131.765C7.9971 132.969 6.5132 134.172 5.0293 135.305C6.30121 133.889 7.57313 132.544 8.91571 131.199C10.2583 129.853 11.6009 128.579 13.0141 127.304C14.4273 126.03 15.8406 124.756 17.2538 123.552C18.3844 122.561 19.5857 121.64 20.7869 120.72C20.9989 120.507 21.2816 120.295 21.6349 120.012C21.5642 120.083 21.6349 120.083 21.6349 120.012Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3828 129.074C49.6163 128.365 47.8497 127.657 46.1538 126.808C44.4579 126.029 42.7621 125.179 41.0662 124.33C39.3703 123.48 37.7451 122.56 36.1198 121.639C34.7772 120.86 33.4347 120.082 32.1627 119.303C31.8801 119.161 31.5975 118.949 31.3148 118.807C31.3148 118.807 31.2441 118.807 31.2441 118.736H31.3148C31.6681 118.878 31.9508 119.02 32.3041 119.161C33.7173 119.728 35.0599 120.365 36.4731 121.002C38.169 121.781 39.8649 122.63 41.5608 123.48C43.2567 124.33 44.8819 125.25 46.5071 126.171C48.203 127.091 49.8283 128.011 51.3828 129.074Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M356.442 138.731L345.555 184.824L418.098 202.027L428.985 155.934L356.442 138.731Z",
    fill: "url(#paint1_linear_13096:34708)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M429 155.908C425.396 158.032 421.792 160.015 418.189 162.068C414.585 164.05 410.981 166.033 407.307 168.015C403.491 170.069 399.746 172.051 395.93 174.104C395.789 174.175 395.718 174.246 395.577 174.317C392.256 176.087 388.864 177.857 385.472 179.627L384.978 179.839L384.624 179.415C382.434 176.299 380.172 173.255 377.982 170.14C377.911 170.069 377.841 169.927 377.77 169.785C375.297 166.316 372.753 162.776 370.35 159.236C368.019 155.837 365.616 152.439 363.284 149.04C360.952 145.571 358.621 142.172 356.359 138.703C358.903 141.818 361.376 145.075 363.85 148.261C366.323 151.518 368.796 154.705 371.269 158.032C374.025 161.643 376.71 165.325 379.395 169.007C381.444 171.768 383.423 174.529 385.472 177.291C388.511 175.733 391.549 174.104 394.588 172.618C398.686 170.564 402.714 168.511 406.812 166.458C410.486 164.617 414.09 162.847 417.765 161.077C421.651 159.378 425.326 157.607 429 155.908Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M379.395 170.139C379.324 170.139 379.324 170.209 379.324 170.209C378.9 170.422 378.406 170.705 377.982 170.917C375.791 172.05 373.601 173.042 371.34 174.033C368.584 175.236 365.828 176.369 363.072 177.502C360.316 178.564 357.49 179.626 354.663 180.617C351.837 181.609 349.01 182.529 346.113 183.379C348.798 181.963 351.484 180.688 354.239 179.485C356.995 178.281 359.751 177.148 362.507 176.015C365.263 174.953 368.089 173.82 370.916 172.9C373.177 172.121 375.438 171.342 377.77 170.634C378.335 170.493 378.83 170.351 379.395 170.139C379.324 170.209 379.324 170.139 379.395 170.139Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M418.259 200.513C415.998 198.531 413.878 196.336 411.829 194.212C409.779 192.088 407.73 189.822 405.752 187.627C403.773 185.362 401.795 183.096 399.887 180.83C398.332 178.919 396.848 177.078 395.364 175.095C395.082 174.67 394.728 174.246 394.446 173.821L394.375 173.75L394.446 173.821C394.87 174.175 395.294 174.6 395.647 174.954C397.413 176.582 399.109 178.281 400.735 179.981C402.784 182.105 404.833 184.37 406.812 186.565C408.79 188.831 410.769 191.097 412.676 193.362C414.655 195.699 416.563 198.035 418.259 200.513Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M276.159 0H233.338V27.1882H276.159V0Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M276.159 0C274.463 1.62846 272.697 3.25692 270.93 4.88538C269.164 6.51384 267.397 8.0715 265.63 9.62916C263.793 11.2576 261.956 12.8861 260.048 14.5145C259.977 14.5853 259.907 14.5853 259.907 14.6562C258.282 16.0722 256.586 17.4883 254.96 18.9751L254.748 19.1875L254.536 18.9751C252.911 17.5591 251.215 16.143 249.59 14.6562C249.519 14.5853 249.449 14.5853 249.449 14.5145C247.612 12.8861 245.704 11.2576 243.867 9.62916C242.1 8.0715 240.333 6.44304 238.567 4.88538C236.8 3.25692 235.034 1.69926 233.338 0C235.175 1.41605 237.012 2.90291 238.779 4.38977C240.616 5.87662 242.383 7.36348 244.22 8.85033C246.198 10.5496 248.248 12.1781 250.226 13.9481C251.71 15.2226 253.194 16.497 254.748 17.7715C256.232 16.497 257.716 15.2226 259.271 13.9481C261.249 12.2489 263.299 10.5496 265.277 8.85033C267.044 7.36348 268.881 5.87662 270.718 4.38977C272.485 2.90291 274.322 1.41605 276.159 0Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M250.296 14.5137C250.296 14.5137 250.226 14.5845 250.296 14.5137C250.014 14.7261 249.802 14.9385 249.59 15.1509C248.53 16.0713 247.399 16.921 246.269 17.7706C244.926 18.8326 243.513 19.8239 242.1 20.8151C240.686 21.8063 239.273 22.7268 237.86 23.718C236.447 24.6385 234.963 25.5589 233.408 26.4085C234.68 25.2757 236.023 24.2136 237.436 23.1516C238.779 22.0896 240.192 21.0983 241.605 20.1071C243.018 19.1158 244.431 18.1954 245.915 17.2042C247.046 16.4961 248.247 15.7173 249.448 15.0801C249.66 14.8677 249.943 14.7261 250.296 14.5137C250.226 14.5845 250.296 14.5137 250.296 14.5137Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M276.017 26.3382C274.534 25.4886 273.05 24.5681 271.566 23.6477C270.153 22.7273 268.669 21.736 267.255 20.7448C265.842 19.7536 264.429 18.7623 263.086 17.7003C261.956 16.8507 260.896 16.001 259.836 15.0806C259.624 14.8682 259.412 14.7266 259.129 14.5142C259.129 14.5142 259.129 14.5142 259.059 14.4434H259.129C259.412 14.585 259.695 14.7266 259.977 14.939C261.178 15.647 262.309 16.355 263.51 17.0631C264.924 17.9835 266.407 18.9747 267.75 19.966C269.163 20.9572 270.576 21.9484 271.919 23.0105C273.403 24.1433 274.746 25.2054 276.017 26.3382Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M324 41H93C89.6863 41 87 43.6863 87 47V198C87 201.314 89.6863 204 93 204H324C327.314 204 330 201.314 330 198V47C330 43.6863 327.314 41 324 41Z",
    fill: "#DBDBDB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M322.238 42.9883H94.7617C91.448 42.9883 88.7617 45.6746 88.7617 48.9883V196.014C88.7617 199.328 91.448 202.014 94.7617 202.014H322.238C325.552 202.014 328.238 199.328 328.238 196.014V48.9883C328.238 45.6746 325.552 42.9883 322.238 42.9883Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M314.749 55.0762H102.303V189.925H314.749V55.0762Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M314.75 55.0762H102.139V60.2648H314.75V55.0762Z",
    fill: "#455A64"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.212 57.6699C106.212 58.3875 105.662 58.9395 104.946 58.9395C104.23 58.9395 103.68 58.3875 103.68 57.6699C103.68 56.9524 104.23 56.4004 104.946 56.4004C105.662 56.4004 106.212 56.9524 106.212 57.6699Z",
    fill: "#C7C7C7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M111.497 57.6699C111.497 58.3875 110.947 58.9395 110.231 58.9395C109.515 58.9395 108.965 58.3875 108.965 57.6699C108.965 56.9524 109.515 56.4004 110.231 56.4004C110.892 56.4004 111.497 56.9524 111.497 57.6699Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.728 57.6699C116.728 58.3875 116.177 58.9395 115.462 58.9395C114.746 58.9395 114.195 58.3875 114.195 57.6699C114.195 56.9524 114.746 56.4004 115.462 56.4004C116.122 56.4004 116.728 56.9524 116.728 57.6699Z",
    fill: "#FFC727"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M314.75 60.2637H310.951V189.924H314.75V60.2637Z",
    fill: "#DBDBDB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M312.823 105.194C312.272 105.194 311.832 104.753 311.832 104.201V61.974C311.832 61.4221 312.272 60.9805 312.823 60.9805C313.374 60.9805 313.814 61.4221 313.814 61.974V104.201C313.814 104.753 313.374 105.194 312.823 105.194Z",
    fill: "#A6A6A6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M278.03 68.4336H163.521V72.7942H278.03V68.4336Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M278.085 72.85H163.467V68.3789H278.03V72.85H278.085Z",
    fill: "#EBEBEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M278.086 68.3789H273.627V72.85H278.086V68.3789Z",
    fill: "#FFC727"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M277.204 71.7999L276.819 72.1311L276.048 71.1375L275.828 70.8063C275.883 70.8063 275.938 70.7511 275.993 70.6959C276.103 70.6407 276.158 70.5303 276.213 70.4199L276.489 70.8063L277.204 71.7999Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M276.435 69.4823C276.049 68.9855 275.389 68.9303 274.893 69.2615C274.398 69.6479 274.343 70.3102 274.673 70.807C275.003 71.2486 275.609 71.359 276.049 71.083C276.104 71.0278 276.159 71.0278 276.215 70.9726C276.325 70.9174 276.38 70.807 276.435 70.7518C276.71 70.4206 276.71 69.8687 276.435 69.4823ZM275.939 70.6966C275.884 70.7518 275.829 70.7518 275.774 70.807C275.499 70.9174 275.169 70.8622 275.003 70.5862C274.783 70.3102 274.838 69.8687 275.113 69.6479C275.389 69.4271 275.829 69.4823 276.049 69.7583C276.214 69.9791 276.215 70.1999 276.159 70.4206C276.104 70.531 276.049 70.6414 275.939 70.6966Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M164.623 69.2617H164.402V71.9112H164.623V69.2617Z",
    fill: "#C7C7C7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M303.298 72.9606C303.078 73.071 302.858 73.1814 302.583 73.2366C301.922 73.4022 301.262 73.2918 300.711 72.9606C300.16 72.6294 299.775 72.0774 299.61 71.4151C299.28 70.0903 300.105 68.7655 301.427 68.4344C302.748 68.1032 304.069 68.9311 304.399 70.2559C304.675 71.3047 304.179 72.4086 303.298 72.9606Z",
    fill: "#FFC727"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M302.748 70.5872C302.748 71.0288 302.418 71.36 301.978 71.36C301.537 71.36 301.207 71.0288 301.207 70.5872C301.207 70.1456 301.537 69.8145 301.978 69.8145C302.418 69.8145 302.748 70.1456 302.748 70.5872Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M303.298 72.6294V72.9606C303.078 73.071 302.858 73.1814 302.583 73.2366C301.922 73.4022 301.261 73.2918 300.711 72.9606V72.6294C300.711 71.9119 301.317 71.3047 302.032 71.3047C302.748 71.3599 303.298 71.9119 303.298 72.6294Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M294.71 73.3467H293.004V72.7396C293.004 72.6844 293.004 72.6844 292.949 72.6844C292.894 72.6292 292.839 72.6292 292.784 72.574C292.729 72.574 292.729 72.574 292.674 72.574L292.123 72.9051L291.242 71.4148L291.793 71.0836C291.848 71.0836 291.848 71.0284 291.848 70.9732C291.848 70.918 291.848 70.918 291.848 70.8628C291.848 70.8076 291.848 70.8076 291.848 70.7524C291.848 70.6972 291.848 70.6972 291.793 70.642L291.242 70.3108L292.123 68.8205L292.674 69.1517C292.729 69.1517 292.729 69.1517 292.784 69.1517C292.839 69.0965 292.894 69.0965 292.949 69.0413C293.004 69.0413 293.004 68.9861 293.004 68.9861V68.3789H294.71V68.9861C294.71 69.0413 294.71 69.0413 294.766 69.0413C294.821 69.0965 294.876 69.0965 294.931 69.1517C294.986 69.1517 294.986 69.1517 295.041 69.1517L295.591 68.8205L296.472 70.3108L295.922 70.642C295.867 70.642 295.867 70.6972 295.867 70.7524C295.867 70.8076 295.867 70.8076 295.867 70.8628C295.867 70.918 295.867 70.918 295.867 70.9732C295.867 71.0284 295.867 71.0284 295.922 71.0836L296.472 71.4148L295.591 72.9051L295.041 72.574C294.986 72.574 294.986 72.574 294.931 72.574C294.876 72.6292 294.821 72.6292 294.766 72.6844C294.71 72.6844 294.71 72.7396 294.71 72.7396V73.3467ZM293.444 72.9051H294.325V72.7396C294.325 72.5188 294.435 72.3532 294.6 72.298C294.655 72.298 294.71 72.2428 294.766 72.1876C294.931 72.0772 295.151 72.0772 295.316 72.1876L295.481 72.298L295.922 71.5252L295.756 71.4148C295.591 71.3044 295.481 71.1388 295.481 70.918V70.8076V70.6972C295.481 70.4764 295.591 70.3108 295.756 70.2004L295.922 70.09L295.481 69.3173L295.316 69.4277C295.151 69.5381 294.931 69.5381 294.766 69.4277C294.71 69.3725 294.655 69.3725 294.6 69.3173C294.435 69.2069 294.325 69.0413 294.325 68.8757V68.7101H293.444V68.8757C293.444 69.0965 293.334 69.2621 293.169 69.3173C293.114 69.3173 293.059 69.3725 293.004 69.4277C292.839 69.5381 292.618 69.5381 292.453 69.4277L292.288 69.3173L291.848 70.09L292.013 70.2004C292.178 70.3108 292.288 70.4764 292.288 70.6972V70.8076V70.918C292.288 71.1388 292.178 71.3044 292.013 71.4148L291.848 71.5252L292.288 72.298L292.453 72.1876C292.618 72.0772 292.839 72.0772 293.004 72.1876C293.059 72.2428 293.114 72.2428 293.169 72.298C293.334 72.4084 293.444 72.574 293.444 72.7396V72.9051ZM293.885 72.1324C293.169 72.1324 292.618 71.5804 292.618 70.8628C292.618 70.1452 293.169 69.5933 293.885 69.5933C294.6 69.5933 295.151 70.1452 295.151 70.8628C295.151 71.5252 294.6 72.1324 293.885 72.1324ZM293.885 69.9797C293.444 69.9797 293.059 70.366 293.059 70.8076C293.059 71.2492 293.444 71.6356 293.885 71.6356C294.325 71.6356 294.71 71.2492 294.71 70.8076C294.71 70.366 294.325 69.9797 293.885 69.9797Z",
    fill: "#DBDBDB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M310.951 90.7891H152.346V99.7864H310.951V90.7891Z",
    fill: "#EBEBEB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 93.9355H159.393V96.6403H162.09V93.9355Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 96.6403H170.844L171.945 95.3155L170.844 93.9355H173.541L174.642 95.3155L173.541 96.6403Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 93.9355L167.046 94.8187L168.037 94.9843L167.321 95.6467L167.486 96.6403L166.605 96.1987L165.724 96.6403L165.89 95.6467L165.174 94.9843L166.165 94.8187L166.605 93.9355Z",
    fill: "#FFC727"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 94.7637H176.568V95.8676H198.094V94.7637Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 94.7637H279.627V95.8676H299.17V94.7637Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 94.7637H204.646V95.8676H271.425V94.7637Z",
    fill: "#455A64"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 102.934H159.393V105.638H162.09V102.934Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 105.638H170.844L171.945 104.314L170.844 102.934H173.541L174.642 104.314L173.541 105.638Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 102.934L167.046 103.872L168.037 103.982L167.321 104.7L167.486 105.638L166.605 105.197L165.724 105.638L165.89 104.7L165.174 103.982L166.165 103.872L166.605 102.934Z",
    fill: "#FFC727"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 103.762H176.568V104.866H198.094V103.762Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 103.762H279.627V104.866H299.17V103.762Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 103.762H204.646V104.866H271.425V103.762Z",
    fill: "#455A64"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M310.951 108.84H152.346V117.837H310.951V108.84Z",
    fill: "#EBEBEB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 111.986H159.393V114.691H162.09V111.986Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 114.691H170.844L171.945 113.311L170.844 111.986H173.541L174.642 113.311L173.541 114.691Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 111.986L167.046 112.869L168.037 112.98L167.321 113.697L167.486 114.691L166.605 114.194L165.724 114.691L165.89 113.697L165.174 112.98L166.165 112.869L166.605 111.986Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 112.76H176.568V113.864H198.094V112.76Z",
    fill: "#DBDBDB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 112.76H279.627V113.864H299.17V112.76Z",
    fill: "#DBDBDB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 112.76H204.646V113.864H271.425V112.76Z",
    fill: "#C7C7C7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 120.982H159.393V123.687H162.09V120.982Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 123.687H170.844L171.945 122.307L170.844 120.982H173.541L174.642 122.307L173.541 123.687Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 120.982L167.046 121.866L168.037 122.031L167.321 122.694L167.486 123.687L166.605 123.246L165.724 123.687L165.89 122.694L165.174 122.031L166.165 121.866L166.605 120.982Z",
    fill: "#FFC727"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 121.811H176.568V122.915H198.094V121.811Z",
    fill: "#DBDBDB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 121.811H279.627V122.915H299.17V121.811Z",
    fill: "#DBDBDB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 121.811H204.646V122.915H271.425V121.811Z",
    fill: "#C7C7C7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M310.951 126.834H152.346V135.831H310.951V126.834Z",
    fill: "#EBEBEB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 129.98H159.393V132.685H162.09V129.98Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 132.685H170.844L171.945 131.36L170.844 129.98H173.541L174.642 131.36L173.541 132.685Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 129.98L167.046 130.864L168.037 131.029L167.321 131.747L167.486 132.685L166.605 132.244L165.724 132.685L165.89 131.747L165.174 131.029L166.165 130.864L166.605 129.98Z",
    fill: "#FFC727"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 130.809H176.568V131.913H198.094V130.809Z",
    fill: "#DBDBDB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 130.809H279.627V131.913H299.17V130.809Z",
    fill: "#DBDBDB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 130.809H204.646V131.913H271.425V130.809Z",
    fill: "#C7C7C7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 139.031H159.393V141.736H162.09V139.031Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 141.736H170.844L171.945 140.356L170.844 139.031H173.541L174.642 140.356L173.541 141.736Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 139.031L167.046 139.914L168.037 140.025L167.321 140.742L167.486 141.736L166.605 141.239L165.724 141.736L165.89 140.742L165.174 140.025L166.165 139.914L166.605 139.031Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 139.805H176.568V140.909H198.094V139.805Z",
    fill: "#DBDBDB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 139.805H279.627V140.909H299.17V139.805Z",
    fill: "#DBDBDB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 139.805H204.646V140.909H271.425V139.805Z",
    fill: "#C7C7C7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M310.951 144.883H152.346V153.88H310.951V144.883Z",
    fill: "#EBEBEB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 148.029H159.393V150.734H162.09V148.029Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 150.734H170.844L171.945 149.354L170.844 148.029H173.541L174.642 149.354L173.541 150.734Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 148.029L167.046 148.912L168.037 149.078L167.321 149.74L167.486 150.734L166.605 150.237L165.724 150.734L165.89 149.74L165.174 149.078L166.165 148.912L166.605 148.029Z",
    fill: "#FFC727"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 148.803H176.568V149.907H198.094V148.803Z",
    fill: "#DBDBDB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 148.803H279.627V149.907H299.17V148.803Z",
    fill: "#DBDBDB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 148.803H204.646V149.907H271.425V148.803Z",
    fill: "#C7C7C7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 157.027H159.393V159.732H162.09V157.027Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 159.732H170.844L171.945 158.407L170.844 157.027H173.541L174.642 158.407L173.541 159.732Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 157.027L167.046 157.911L168.037 158.076L167.321 158.738L167.486 159.732L166.605 159.29L165.724 159.732L165.89 158.738L165.174 158.076L166.165 157.911L166.605 157.027Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 157.855H176.568V158.959H198.094V157.855Z",
    fill: "#DBDBDB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 157.855H279.627V158.959H299.17V157.855Z",
    fill: "#DBDBDB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 157.855H204.646V158.959H271.425V157.855Z",
    fill: "#C7C7C7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M310.951 162.879H152.346V171.876H310.951V162.879Z",
    fill: "#EBEBEB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 166.025H159.393V168.73H162.09V166.025Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 168.73H170.844L171.945 167.405L170.844 166.025H173.541L174.642 167.405L173.541 168.73Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 166.025L167.046 166.964L168.037 167.074L167.321 167.792L167.486 168.73L166.605 168.289L165.724 168.73L165.89 167.792L165.174 167.074L166.165 166.964L166.605 166.025Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 166.854H176.568V167.957H198.094V166.854Z",
    fill: "#DBDBDB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 166.854H279.627V167.957H299.17V166.854Z",
    fill: "#DBDBDB"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 166.854H204.646V167.957H271.425V166.854Z",
    fill: "#C7C7C7"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 175.076H159.393V177.781H162.09V175.076Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 177.781H170.844L171.945 176.401L170.844 175.076H173.541L174.642 176.401L173.541 177.781Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 175.076L167.046 175.959L168.037 176.07L167.321 176.787L167.486 177.781L166.605 177.284L165.724 177.781L165.89 176.787L165.174 176.07L166.165 175.959L166.605 175.076Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 175.85H176.568V176.954H198.094V175.85Z",
    fill: "#DBDBDB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 175.85H279.627V176.954H299.17V175.85Z",
    fill: "#DBDBDB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 175.85H204.646V176.954H271.425V175.85Z",
    fill: "#C7C7C7"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M310.951 180.928H152.346V189.925H310.951V180.928Z",
    fill: "#EBEBEB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M162.09 184.074H159.393V186.779H162.09V184.074Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 186.779H170.844L171.945 185.399L170.844 184.074H173.541L174.642 185.399L173.541 186.779Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 184.074L167.046 184.957L168.037 185.123L167.321 185.785L167.486 186.779L166.605 186.337L165.724 186.779L165.89 185.785L165.174 185.123L166.165 184.957L166.605 184.074Z",
    fill: "#FFC727"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M198.094 184.902H176.568V186.006H198.094V184.902Z",
    fill: "#DBDBDB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17 184.902H279.627V186.006H299.17V184.902Z",
    fill: "#DBDBDB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M271.425 184.902H204.646V186.006H271.425V184.902Z",
    fill: "#C7C7C7"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M198.093 82.6758H168.09V85.8773H198.093V82.6758Z",
    fill: "#DBDBDB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M163.466 82.6758H159.393V85.8773H163.466V82.6758Z",
    fill: "#DBDBDB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M163.466 82.6758C163.301 82.8414 163.136 83.007 162.971 83.2278C162.806 83.3934 162.641 83.559 162.475 83.7245C162.31 83.8901 162.145 84.0557 161.925 84.2765C161.76 84.4421 161.595 84.6077 161.43 84.7181C161.264 84.5525 161.099 84.3869 160.934 84.2765C160.769 84.1109 160.604 83.9453 160.384 83.7245C160.218 83.559 160.053 83.3934 159.888 83.2278C159.723 83.0622 159.558 82.8966 159.393 82.6758C159.558 82.8414 159.723 83.007 159.888 83.1726C160.053 83.3382 160.218 83.5038 160.384 83.6693C160.549 83.8349 160.769 84.0557 160.934 84.2213C161.099 84.3317 161.209 84.4973 161.374 84.6077C161.54 84.4973 161.65 84.3317 161.815 84.2213C161.98 84.0557 162.2 83.8349 162.365 83.6693C162.531 83.5038 162.696 83.3382 162.861 83.1726C163.136 82.9518 163.301 82.7862 163.466 82.6758Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M160.989 84.166C160.989 84.2212 160.934 84.2212 160.934 84.2764C160.824 84.3868 160.714 84.5524 160.604 84.6628C160.494 84.8284 160.328 84.9388 160.218 85.1044C160.108 85.27 159.943 85.3804 159.833 85.546C159.668 85.6564 159.558 85.822 159.393 85.9324C159.503 85.7668 159.668 85.6012 159.778 85.4356C159.888 85.27 160.053 85.1596 160.163 84.994C160.273 84.8284 160.439 84.718 160.549 84.5524C160.659 84.442 160.769 84.3316 160.879 84.2212C160.934 84.2212 160.989 84.166 160.989 84.166Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M163.466 85.8777C163.3 85.7673 163.19 85.6017 163.025 85.4913C162.86 85.3809 162.75 85.2153 162.64 85.0497C162.53 84.8841 162.365 84.7737 162.255 84.6081C162.144 84.4977 162.034 84.3321 161.924 84.2217C161.924 84.1665 161.869 84.1665 161.869 84.1113L161.924 84.1665C162.034 84.2769 162.144 84.3873 162.255 84.4977C162.42 84.6081 162.53 84.7737 162.64 84.9393C162.75 85.1049 162.915 85.2153 163.025 85.3809C163.19 85.5465 163.356 85.7121 163.466 85.8777Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M248.634 82.6758H218.631V85.8773H248.634V82.6758Z",
    fill: "#DBDBDB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M211.749 83.7797C211.749 84.1661 211.419 84.4421 211.088 84.4421C210.703 84.4421 210.428 84.1109 210.428 83.7797C210.428 83.3934 210.758 83.1174 211.088 83.1174C211.474 83.0622 211.749 83.3934 211.749 83.7797Z",
    fill: "#DBDBDB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M212.244 85.6571V85.9331H209.877V85.6571C209.877 84.9947 210.427 84.498 211.033 84.498C211.749 84.4428 212.244 84.9947 212.244 85.6571Z",
    fill: "#DBDBDB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M213.511 83.3382C213.511 83.7245 213.18 84.0005 212.85 84.0005C212.465 84.0005 212.189 83.6693 212.189 83.3382C212.189 82.9518 212.52 82.6758 212.85 82.6758C213.18 82.6758 213.511 82.9518 213.511 83.3382Z",
    fill: "#DBDBDB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M214.006 85.2158V85.4918H211.639V85.2158C211.639 84.5534 212.189 84.0566 212.795 84.0566C213.455 84.0566 214.006 84.5534 214.006 85.2158Z",
    fill: "#DBDBDB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M299.115 82.6758H269.111V85.8773H299.115V82.6758Z",
    fill: "#DBDBDB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M264.543 82.6758H260.414V85.8773H264.488L265.699 84.2765L264.543 82.6758ZM264.543 84.4973C264.433 84.4973 264.323 84.3869 264.323 84.2765C264.323 84.1109 264.433 84.0557 264.543 84.0557C264.708 84.0557 264.763 84.1661 264.763 84.2765C264.818 84.3869 264.708 84.4973 264.543 84.4973Z",
    fill: "#DBDBDB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M152.346 60.2637H102.139V189.924H152.346V60.2637Z",
    fill: "url(#paint2_linear_13096:34708)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M145.3 79.4727H109.131V89.0771H145.3V79.4727Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M114.196 68.3789H109.131V69.2069H114.196V68.3789Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M114.196 72.0215H109.131V72.8495H114.196V72.0215Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M114.196 70.1992H109.131V71.0272H114.196V70.1992Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M125.978 68.3789H118.986V72.85H125.978V68.3789Z",
    fill: "#EBEBEB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M125.978 68.3789V72.85H118.986V68.3789C119.262 68.5445 119.592 68.7101 119.867 68.9309C120.142 69.0965 120.473 69.2621 120.748 69.4829C121.078 69.7037 121.409 69.8693 121.739 70.09C121.959 70.2556 122.234 70.4212 122.455 70.5316C122.675 70.366 122.95 70.2004 123.17 70.09C123.501 69.8693 123.831 69.7037 124.161 69.4829C124.436 69.3173 124.767 69.0965 125.042 68.9309C125.372 68.7101 125.703 68.5445 125.978 68.3789Z",
    fill: "#EBEBEB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M125.977 68.3789C125.702 68.5997 125.427 68.7653 125.097 68.9861C124.821 69.1517 124.546 69.3725 124.216 69.5381C123.941 69.7589 123.61 69.9245 123.28 70.1452C123.005 70.3108 122.729 70.4764 122.454 70.642H122.399H122.344C122.069 70.4764 121.793 70.3108 121.518 70.1452C121.518 70.1452 121.518 70.1452 121.463 70.1452C121.133 69.9245 120.858 69.7589 120.527 69.5381C120.252 69.3725 119.977 69.1517 119.646 68.9861C119.371 68.7653 119.096 68.5997 118.766 68.3789C119.041 68.5445 119.371 68.7101 119.646 68.9309C119.922 69.0965 120.252 69.2621 120.527 69.4829C120.858 69.7037 121.188 69.8693 121.518 70.09C121.738 70.2556 122.014 70.4212 122.234 70.5316C122.454 70.366 122.729 70.2004 122.95 70.09C123.28 69.8693 123.61 69.7037 123.941 69.4829C124.216 69.3173 124.546 69.0965 124.821 68.9309C125.372 68.7101 125.702 68.5445 125.977 68.3789Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M121.739 70.0352C121.684 70.0904 121.684 70.0904 121.629 70.1456C121.464 70.3111 121.299 70.4215 121.078 70.5871C120.858 70.7527 120.638 70.9183 120.418 71.0839C120.197 71.2495 119.977 71.4151 119.702 71.5807C119.482 71.7463 119.207 71.8567 118.986 72.0223C119.207 71.8567 119.427 71.6359 119.647 71.4703C119.867 71.3047 120.087 71.1391 120.308 70.9735C120.528 70.8079 120.748 70.6423 121.023 70.4767C121.188 70.3663 121.409 70.2559 121.574 70.1456C121.629 70.0904 121.684 70.0904 121.739 70.0352Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M125.977 71.9656C125.757 71.8552 125.482 71.6897 125.262 71.5241C125.041 71.3585 124.766 71.1929 124.546 71.0273C124.326 70.8617 124.105 70.6961 123.885 70.5305C123.72 70.3649 123.5 70.2545 123.335 70.0889C123.28 70.0337 123.28 70.0337 123.225 69.9785C123.28 69.9785 123.335 70.0337 123.335 70.0337C123.555 70.1441 123.72 70.2545 123.885 70.3649C124.105 70.5305 124.381 70.6961 124.601 70.8617C124.821 71.0273 125.041 71.1929 125.262 71.3585C125.537 71.6345 125.757 71.8 125.977 71.9656Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M152.346 97.4668H102.139V104.311H152.346V97.4668Z",
    fill: "#020100"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M138.253 98.957H109.131V102.986H138.253V98.957Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M138.253 106.795H109.131V110.824H138.253V106.795Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M138.253 114.689H109.131V118.719H138.253V114.689Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M138.253 122.527H109.131V126.557H138.253V122.527Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M144.474 130.42H115.352V134.449H144.474V130.42Z",
    fill: "#455A64"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M144.474 138.258H115.352V142.287H144.474V138.258Z",
    fill: "#455A64"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M138.253 146.152H109.131V150.182H138.253V146.152Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M138.253 153.99H109.131V158.02H138.253V153.99Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M60 192.117C64.8156 204.541 94.1469 219.528 126.762 209.964C161.93 199.66 160.617 160.565 206 144",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeDasharray: "4.01 4.01"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M208.652 142.988C209.341 142.644 210.029 142.301 210.718 141.957",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M206.242 129.469L199.127 149.176L214.161 137.489L272 116.521L206.242 129.469Z",
    fill: "#FFC727"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M206.242 129.469L199.127 149.176L214.161 137.489L272 116.521L206.242 129.469Z",
    fill: "url(#paint3_linear_13096:34708)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M216.111 142.071L199.127 149.175L214.161 137.488L216.111 142.071Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M214.162 137.489L272.001 116.521L224.605 162.696L214.162 137.489Z",
    fill: "url(#paint4_linear_13096:34708)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M206.243 129.468L182.258 114L272 116.521L206.243 129.468Z",
    fill: "url(#paint5_linear_13096:34708)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_13096:34708",
    x: -0.955078,
    y: 41.7363,
    width: 34.8516,
    height: 34.9102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13096:34708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13096:34708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_13096:34708",
    x: 341.555,
    y: 134.73,
    width: 91.4297,
    height: 71.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13096:34708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13096:34708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13096:34708",
    x1: 16.4708,
    y1: 45.7363,
    x2: 16.4708,
    y2: 72.6456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64375,
    stopColor: "#A4CDFF",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4CDFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13096:34708",
    x1: 350.998,
    y1: 161.778,
    x2: 423.557,
    y2: 178.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154505,
    stopColor: "#A4CDFF",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4CDFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13096:34708",
    x1: 127.242,
    y1: 60.2637,
    x2: 127.242,
    y2: 189.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFD604",
    stopOpacity: 0.699
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13096:34708",
    x1: 235.563,
    y1: 116.521,
    x2: 235.563,
    y2: 149.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.30411,
    stopColor: "#0043A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D9AF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13096:34708",
    x1: 243.082,
    y1: 116.521,
    x2: 243.082,
    y2: 162.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3625,
    stopColor: "#5D9AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13096:34708",
    x1: 227.129,
    y1: 114,
    x2: 227.129,
    y2: 129.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043A2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeToJoinOrgIcon);
export default __webpack_public_path__ + "static/media/WelcomeToJoinOrgIcon.45f743ef.svg";
export { ForwardRef as ReactComponent };